// FNP-904 — the console's ONLY write to a DefectSignature.
//
// `UpdateDefectSignatureInput` is deliberately narrow: {id, status, jiraKey}.
// The counters, timestamps and error text belong to the sweep, and a mutation
// that echoed the whole object back would let a stale browser tab overwrite
// fields it never intended to touch (the platform's mutation-whitelist rule).

export const updateDefectSignature = `
   mutation updateDefectSignature($input: UpdateDefectSignatureInput!) {
       updateDefectSignature(input: $input) {
           id
           status
           jiraKey
           updated
       }
   }
`;

// FNP-969 — DELETE, which is NOT the triage path and NOT "this defect is fixed".
//
// ═══ THE THREE VERBS, WHICH ARE EASY TO CONFUSE AND MUST NOT BE ═══
//
//   updateDefectSignature  TRIAGE. "I acknowledge this" / "I filed it as FNP-x."
//                          The signature stays; its status moves. This is what an
//                          operator wants ~always.
//
//   resolveDefectSignature "This stopped happening." Concluded by the SWEEP from
//                          an ABSENCE of occurrences. It is @aws_iam and has no
//                          console affordance at all — deliberately, because
//                          "fixed" must be an evidence-based conclusion, not a
//                          click. (Same reasoning as abandonTestRun.)
//
//   deleteDefectSignature  CLEARING AN ENVIRONMENT. Discards the signature and
//                          the history of how often it fired. Use when the rows
//                          are noise from a torn-down environment — never to say
//                          a defect is fixed.
//
// An operator who deletes when they meant to resolve destroys the occurrence
// history that made the defect legible. The UI states this at the point of
// action; see buttons/DeleteRecordButton.tsx.
//
// Returns `ID` (the deleted id), not the row — there is no row left to return.
export const deleteDefectSignature = `
   mutation deleteDefectSignature($id: ID!) {
       deleteDefectSignature(id: $id)
   }
`;
